import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

export interface OwnershipStatusIndicatorProps {
  isConfirmed: boolean;
  className?: string;
}

export const OwnershipStatusIndicator = ({
  isConfirmed,
  className,
}: Readonly<OwnershipStatusIndicatorProps>) => {
  return isConfirmed ? (
    <CheckCircleIcon className={className} style={{ color: '#2e7d32' }} />
  ) : (
    <WarningIcon className={className} style={{ color: '#ed6c02' }} />
  );
};
